// extracted by mini-css-extract-plugin
export default {"spaceBetween":"Plot_spaceBetween__1rX+6","dim":"Plot_dim__Re65G","cropContainer":"Plot_cropContainer__0ryiD"};